<template>
    <div class="templategroup-view has-header">
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
        <div class="header main">
            <div class = "align-left">
                <dateselectionheader
                             :label="dateDisplay"
                            @PrevDate="SelectPreviousDate"
                            @NextDate="SelectNextDate"
                            @CalendarOpen="toggleDatePicker"
                            @SetToday="SelectToday"/>
            </div>
            <div class = "align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class = "align-right">
            </div>
        </div>


        <div class="scrollbar-container">
            <div class="sub-header" v-if="displayedTimeframeSelected.label === 'M'">
                <div class="title" v-bind:style="{width: GetWidthFirstTitle()}">
                    <div class="label ">{{timeFrameStart.format("MMMM")}}</div>
                </div>

            </div>

            <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'Y'">
                <div class="background"></div>
                <div class="day" v-for="(month, indexD) in monthsDisplayed" :key="indexD"  v-bind:style="[GetTimeMarkWidth(indexD)]">

                    <div class="day-text" v-on:click="SelectMonth(month)">
                        <div class="name">{{ $helpers.translateMonth(month.name)}}
                        </div>

                    </div>

                </div>
            </div>
            <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'M'">
                <div class="background"></div>
                <div class="day" v-for="(day, indexD) in daysDisplayed" :key="indexD"  v-bind:style="[GetTimeMarkWidth(indexD)]">

                    <div class="day-text">
                        <div class="name">{{ $helpers.translateDayShort(day.name)}} hallo
                        </div>
                        <div class="date">{{day.date}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="grid">

                <div class="header">
                    <div class="label">{{ $t('shift.main.groups') }}</div>
                     <!--
                    <div class="employee-filter button" v-on:click="OpenFilterPopup($event)">
                    <div class="label" style="padding-left: 4px; padding-top: 1px;">
                        <i class="fas fa-filter"></i>
                    </div>
                    </div>
                    -->

                </div>

                <div class="backdrop"></div>

                <div class="group">
                    <div class="header" >

                        <div class="label">{{ $t('shift.main.groups') }}</div>


                    </div>

                    <div class="row" v-for="(group) in shiftTemplateGroups" :key="group.id" >
                        <div class="templategroup" v-tooltip="() => group.description">
                            <div class="background" ></div>
                            <div class="background shadow" ></div>

                            <div class="name">{{group.name}}</div>



                            <div style= "width: 30px; height: 30px;">
                                    <div class="fa-stack detail"
                                    v-bind:style="{'z-index': 99}" v-on:click="OpenGroupFrameButtonMenu($event, group)">
                                        <i style="font-size:25px; right:0px;" class="fas fa-circle fa-stack-2x"></i>
                                        <i style="font-size:25px; margin-left:-1px;" class="fas fa-cog fa-stack-2x"></i>
                                    </div>
                            </div>

                        </div>

                        <div class="timeframe" v-for="(timeFrame) in groupFramesByGroupMap[group.id]" :key="timeFrame.key" v-bind:style="[GetTimeFrameStyles(timeFrame)]" v-bind:id="timeFrame.frame.id" v-tooltip="getGroupFrameTooltip(timeFrame.frame.id, timeFrame.shiftFrame)"
                             v-on:mouseup="SelectTimeFrame($event, timeFrame)" v-on:mouseenter="CheckLabelLength($event)">

                            <div class="handle start" v-if="showTimeFrameHandles && timeFrame.frame.from != null && !timeFrame.shiftFrame" v-on:mousedown="StartDragTimeFrame($event, timeFrame, true)"><div class="inner"></div></div>
                            <div class="handle end" v-if="showTimeFrameHandles && timeFrame.frame.to != null && !timeFrame.shiftFrame" v-on:mousedown="StartDragTimeFrame($event, timeFrame, false)"><div class="inner"></div></div>
                            <div class="label"></div>
                            <div class="shadow"></div>

                        </div>
                        <div class="top-line"></div>
                        <div class="bottom-line"></div>
                    </div>
                </div>
                <div class="time-marks" v-bind:class="{monthly: displayedTimeframeSelected.label === 'Y'}">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
                    </div>
                </div>
                <div class="time-marks labels" v-if="displayedTimeframeSelected.label === 'D'">
                    <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark" v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
                        <div class="label" v-if="displayedTimeframeSelected.label !== 'M'">{{displayedTimeframeSelected.label !== 'Y' ? mark : displayedTimeframeSelected.timeStart.clone().month(indexMark).format('MMM')}}</div>
                    </div>
                </div>
            </div>
        </div>




    </div>


</template>

<script>

import { mapState, mapGetters } from 'vuex';
export default {
  name: 'templategroupview',
    components: {

    },
    data () {
        return {
            displayedTimeframes: [],
            displayedTimeframeSelected: null,
            timeFrameStart: this.$helpers.getMomentTZ().startOf('year'),
            timeFrameEnd: this.$helpers.getMomentTZ().startOf('year').add(1, 'year'),
            timeFrameLength: 365 * 24 * 60 * 60 * 1000,
            currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
            currentMonth: this.$helpers.getCurrentMonthMomentTZ().startOf('year').month(),
            currentDate: 1,
            error: false,
            loading: true,
            loadingText: null,
            frameShiftIntervalMap: {},

            dragging: false,
            draggingTimeFrame: null,
            draggingTime: null,
            draggingStart: false,
            draggingStartPos: {x: 0, y: 0},
            draggingHandle: null,
            draggingGroup: null,
        }
    },
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            if(this.rosterFromTo != null){
                let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, 1, 1);
                this.onDatePicked(startDate, 'Y', 24);
            } else {
                this.onDatePicked(this.$helpers.getCurrentMonthMomentTZ(), 'Y', 24);
            }
        }
    },
    mounted: function() {
        this.refresh();
    },
    computed: {
        ...mapGetters(['storeId', 'shiftTemplateGroupMap', 'shiftTemplateGroupFrameMap', 'storeSettings', 'rosterFromTo', 'isSuperUser']),
        dateDisplay: function() {
            if(this.timeFrameStart != null){
                if(this.displayedTimeframeSelected.label === 'D') return this.timeFrameStart.format('DD.MM.YYYY');
                if(this.displayedTimeframeSelected.label === 'M') return this.timeFrameStart.format('MMM YYYY');
                if(this.displayedTimeframeSelected.label === 'Y') return this.timeFrameStart.format('YYYY');
                return '-';
            } else {
                return '-';
            }

        },
        showTimeFrameHandles() {
            return this.displayedTimeframeSelected.label === 'M';
        },
        daysDisplayed(){
            let days = [];
            let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
            for(let x = 0; x < date.daysInMonth(); x++){
                date.date(x + 1);
                days.push({
                    name: date.format('dddd').substring(0,2),
                    date: date.format('DD').substring(0,2) + '.' + date.format('MM').substring(0,2),
                    moment: date.clone(),
                });
            }
            return days;

        },
        monthsDisplayed(){
            let days = [];
            let date = this.$helpers.getMomentTZ().date(1).month(0).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
            for(let x = 0; x < 12; x++){

                days.push({
                    name: date.format('MMMM'),

                    moment: date.clone(),
                });
                date.add(1, 'months');
            }
            return days;

        },
        timeMarks(){

            let marks = [];

            let timeFrame = this.displayedTimeframeSelected;
            for(let x = 0; x < timeFrame.divisions; x++){
                let timemark = (x + 1 > 9 ? x + 1 : '0' + (x + 1));

                if(timeFrame.length <= 48 * 60 * 60 * 1000) timemark = ((x % 24) > 9 ? (x % 24) : '0' + (x % 24));

                marks.push(timemark.toString());
            }
            return marks;
        },
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            if(this.displayedTimeframeSelected.label !=  'Y'){
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-chevron-left",
                    click: () => {view.onDatePicked(view.timeFrameStart.clone().startOf('year'), 'Y', 24);},
                    tooltip: this.$t('shift.groups.backToYear')
                });
            }
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true);
                },
                tooltip: this.$t('global.general.refreshData')
            });
            if(Object.values(view.shiftTemplateGroupMap).length < 20){
                state.buttons.push({type: "block green",icon: "fa-layer-plus",click: ($event) => {view.OpenNewShiftTemplateGroupPopup($event);},tooltip: this.$t('shift.groups.addShift'), helperText: this.$t('shift.groups.addShiftHelp'), externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2557542403"});
            }
            if(Object.values(view.shiftTemplateGroupMap).filter(g => g.immutable == false).length > 0){
                state.buttons.push({type: "block red",icon: "fa-layer-minus",click: ($event) => {view.OpenDeleteShiftTemplateGroupPopup($event);},tooltip: this.$t('shift.groups.deleteShift'), helperText: this.$t('shift.groups.deleteShiftHelp'), externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2557542403"});
            }



            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];
            return state;
        },
        shiftTemplateGroups() {
            return Object.values(this.shiftTemplateGroupMap).sort((a,b) => {
                if(a.immutable && !b.immutable){
                    return -1;
                } else {
                    return a.name.localeCompare(b.name);
                }
            })
        },
        groupFramesByGroupMap(){
            let view = this;
            let map = {};
            let startOfYear = this.$helpers.getMomentFromValuesTZ(this.currentYear, 0, 1);
            let endOfYear = startOfYear.clone().add(1, 'year');
            Object.values(this.shiftTemplateGroupFrameMap).sort((a, b) => {
                if(a.from == null){
                    return -1;
                }
                if(b.from == null){
                        return 1;
                }
                let aFrom = view.$helpers.getMomentTZ(a.from);
                let bFrom = view.$helpers.getMomentTZ(b.from);
                return aFrom - bFrom;
            }).forEach(frame => {

                let tf = {key: "tf2-"+frame.id,frame: frame, shiftFrame: false,
                            fromDate: frame.from == null ? startOfYear : view.$helpers.getMomentFromStringTZ(frame.from),
                            toDate: frame.to == null ? endOfYear : view.$helpers.getMomentFromStringTZ(frame.to)}
                if(!map[frame.groupId]){
                    map[frame.groupId] = [];
                }
                map[frame.groupId].push(tf);
                //shift interval frame
                if(view.frameShiftIntervalMap[frame.id]){
                    let shiftInterval = view.frameShiftIntervalMap[frame.id];
                    let actualFrom = view.$helpers.getMomentFromStringTZ(shiftInterval.from).startOf('day');
                    let actualTo = view.$helpers.getMomentFromStringTZ(shiftInterval.to).add(1, 'days').startOf('day')
                    let sf = {key: "sf2-"+frame.id, frame: frame, shiftFrame: true, actualFrom: actualFrom, actualTo: actualTo,
                            fromDate: actualFrom < startOfYear ? startOfYear : actualFrom,
                            toDate: actualTo > endOfYear ? endOfYear : actualTo};
                    map[frame.groupId].push(sf);
                }
            })
            return map;
        },


    },
    watch: {
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
        rosterFromTo(newVal, oldVal) {
            if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();

            }
        },
    },
  // methods that implement data logic.
    methods: {
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            let ids = [];
            this.$helpers.GetShiftTemplateGroupMap(force)
            .then(map => {
                return view.$helpers.GetShiftTemplateGroupFrameMap(force)
            })
            .then(map=>{
                let payload = {ids: []};
                Object.values(map).forEach(e => {
                    payload.ids.push(e.id);
                })
                return view.loadFrameShiftIntervals(payload);

            }).then(data=>{
                view.frameShiftIntervalMap = {};
                data.forEach(e => {
                    view.frameShiftIntervalMap[e.id] = e;
                })
                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        OpenNewShiftTemplateGroupPopup($event){
            let view = this;

            let description = "";
            let dataEntries = [

                {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: '', length: 50},
                {label: this.$t('store.events.description'), key: 'description', hidden: false, type: 'text', value: '', length: 50},


            ];
            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                            (entries) => {

                                if(!entries['name'] || entries['name'].length < 1){
                                    return {key: 'name', type: 'error', label: this.$t('pages.employeeData.name'), text: 'Bitte geben Sie einen Namen für die Schichtgruppe ein!'}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {

                                if(entries['name'] && entries['name'].length > 50){
                                    return {key: 'name', type: 'error', label: this.$t('pages.employeeData.name'), text: 'Der Name der Schichtpgruppe darf maximal 50 Zeichen lang sein!'}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {

                                if(entries['description'] && entries['description'].length > 3000){
                                    return {key: 'description', type: 'error', label: this.$t('store.events.description'), text: 'Die Beschreibung der Schichtgruppe darf maximal 3000 Zeichen lang sein!'}
                                } else {
                                    return null
                                }
                            }
                    ],
                    selectCallback: function (shiftTemplateGroup) {

                        view.CreateShiftTemplateGroup({name: shiftTemplateGroup.name, description: shiftTemplateGroup.description});

                    },
                    description: description
                },
                header: this.$t('shift.groups.addShift'),
                centered: true,
                expanded: true,
            });

        },
        CreateShiftTemplateGroup: function(shiftTemplateGroup){

            let view = this;
            let url = '/api/sec/shifttemplategroup';
            let params =  {
                storeId: this.$store.state.storeId
            }

            let payload = {
                name: shiftTemplateGroup.name,
                description: shiftTemplateGroup.description,
            }


            this.axios({
                method: 'post',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$store.commit("setShiftTemplateGroupMapEntry", response.data.data);
                view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('shift.groups.shiftCreated'))

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.groups.createShiftError'));
            })

        },
        OpenDeleteShiftTemplateGroupPopup($event){
            let view = this;
            let description = this.$t('shift.groups.deleteShiftQuery')
            let items = [];
            Object.values(this.shiftTemplateGroupMap).filter(group => !group.immutable).forEach(group => {
                items.push({label: group.name, value: group.id});
            });
            let dataEntries = [
                {key: 'id', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: items,
                         selectMultiple: false,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('shift.main.group'),
                }},

            ];
            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    selectCallback: function (shiftTemplateGroup) {
                        view.DeleteShiftTemplateGroup(shiftTemplateGroup);
                    }
                },
                header: this.$t('shift.groups.deleteShift'),
                centered: true,
                expanded: true,
            });

        },
        DeleteShiftTemplateGroup: function(shiftTemplateGroup){

            let view = this;
            let url = '/api/sec/shifttemplategroup';


            let params = {
                id: shiftTemplateGroup.id,
                storeId: this.$store.state.storeId
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
            }).then(response => {

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.groups.shiftDeleted'));
                view.$store.commit("deleteShiftTemplateGroupMapEntry", {id: shiftTemplateGroup.id});

                view.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateMapState']});
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.groups.deleteShiftError'));
            })

        },
        OpenEditShiftTemplateGroupPopup($event, group){
            let view = this;

            let description = "";
            let dataEntries = [

                {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: group.name, length: 50},
                {label: this.$t('store.events.description'), key: 'description', hidden: false, type: 'text', value: group.description ? group.description : '', length: 50},


            ];
            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                            (entries) => {

                                if(!entries['name'] || entries['name'].length < 1){
                                    return {key: 'name', type: 'error', label: this.$t('pages.employeeData.name'), text: 'Bitte geben Sie einen Namen für die Schichtgruppe ein!'}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {

                                if(entries['name'] && entries['name'].length > 50){
                                    return {key: 'name', type: 'error', label: this.$t('pages.employeeData.name'), text: 'Der Name der Schichtpgruppe darf maximal 50 Zeichen lang sein!'}
                                } else {
                                    return null
                                }
                            },
                            (entries) => {

                                if(entries['description'] && entries['description'].length > 3000){
                                    return {key: 'description', type: 'error', label: this.$t('store.events.description'), text: 'Die Beschreibung der Schichtgruppe darf maximal 3000 Zeichen lang sein!'}
                                } else {
                                    return null
                                }
                            }
                    ],
                    selectCallback: function (shiftTemplateGroup) {

                        view.EditShiftTemplateGroup({id: group.id, name: shiftTemplateGroup.name, description: shiftTemplateGroup.description});

                    },
                    description: description
                },
                header: this.$t('shift.groups.editShift'),
                centered: true,
                expanded: true,
            });

        },
        EditShiftTemplateGroup: function(shiftTemplateGroup){

            let view = this;
            let url = '/api/sec/shifttemplategroup';
            let params =  {
                storeId: this.$store.state.storeId
            }

            let payload = {
                id: shiftTemplateGroup.id,
                name: shiftTemplateGroup.name,
                description: shiftTemplateGroup.description,
                updateFields: ["name", "description"]
            }


            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let group = view.shiftTemplateGroupMap[payload.id];
                group.name = payload.name;
                group.description = payload.description;
                view.$store.commit("setShiftTemplateGroupMapEntry", group);
                view.$helpers.success(view.$t('global.notifications.savedMessage'), view.$t('global.notifications.shiftEdited'))

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.groups.editShiftError'));
            })

        },
        OpenGroupFrameButtonMenu($event, group){
            let view = this;
            let buttons = [{color: '#6d8d23', icon: 'fa-plus', label: this.$t('global.ui.create'), click: () => { view.OpenCreateShiftTemplateGroupFrameModal($event, group) }}];
            if(!group.immutable){
                buttons.push({color: '#e5c420', icon: 'fa-edit', label: this.$t('global.ui.edit'), click: () => { view.OpenEditShiftTemplateGroupPopup($event, group) }})
            }

            view.$helpers.OpenButtonContainer(buttons, { elRelative: $event.currentTarget, offsetx: 5, offsety: -10,  closeOnSelect: true})

        },

        getGroupFrameTooltip(frameId, shiftFrame){
            let view = this;
            return () => {
                if(shiftFrame){
                    let frame = view.frameShiftIntervalMap[frameId];
                    let from = view.$helpers.getMomentFromStringTZ(frame.from).startOf('day').format("DD.MM.YYYY");
                    let to = view.$helpers.getMomentFromStringTZ(frame.to).startOf('day').format("DD.MM.YYYY");
                    return this.$t('shift.groups.shiftsPlanned') + ": "+from+" - "+to;
                } else {
                    let frame = view.shiftTemplateGroupFrameMap[frameId];
                    let from = frame.from == null ? this.$t('workBalance.bonus.recursIndefinitely') : view.$helpers.getMomentFromStringTZ(frame.from).format("DD.MM.YYYY");
                    let to = frame.to == null ? this.$t('workBalance.bonus.ongoingIndefinitely') : view.$helpers.getMomentFromStringTZ(frame.to).add(-1,'days').format("DD.MM.YYYY");
                    return from+" - "+to;
                }

            }
        },



        GetWidthFirstTitle(){
            let width = 100;
            if(this.displayedTimeframeSelected.divisions === 36) width = 66.6666;
            if(this.displayedTimeframeSelected.divisions === 48) width = 50;
            width += '%';
            return width;
        },
        GetTimeMarkWidth(index) {

            let timeFrame = this.displayedTimeframeSelected;
            if(timeFrame.label === 'Y') {
                let lengthYear = timeFrame.length;
                let lengthMonth = timeFrame.timeStart.clone().month(index).daysInMonth() * 24 * 60 * 60 * 1000;
                let widthMonth =  lengthYear / lengthMonth;
                return {width: ($(this.$el).find('.time-marks').width() / widthMonth) + 'px'};
            }
            return {width: ($(this.$el).find('.time-marks').width() / parseInt(timeFrame.divisions)) + 'px'};
        },
        CheckLabelLength($event){
            let el = $event.currentTarget;
            let box = el.getBoundingClientRect();
            let boxlabel = el.querySelector('.label').getBoundingClientRect();
            if(boxlabel.width > box.width) el.classList.add('show-under');
            else el.classList.remove('show-under');
        },
        SelectTimeFrame($event, timeFrame){
            let view = this;
            if(!view.dragging){
                 let labelOptions = [];

                labelOptions.push({text: this.$t('global.ui.edit'), type: 'block', click: () => {
                        view.OpenEditShiftTemplateGroupFrameModal($event, timeFrame.frame);
                }});
                labelOptions.push({text: this.$t('global.ui.delete'), disabled: view.frameShiftIntervalMap[timeFrame.frame.id] != null, type: 'block', click: () => {
                    view.OpenDeleteShiftTemplateGroupFrameModal($event, timeFrame.frame);
                }});

                this.$helpers.OpenListLabel(labelOptions,{allowOverflow: true});
            }

        },
        GetTimeFrameStyles(timeFrame){

            let totalWidth = $(this.$el).find('.time-marks').width();
            let timePixelRatio = totalWidth / this.timeFrameLength;


            let background = timeFrame.shiftFrame ? '#6d8d23' :'';
            let boxShadow = 'inset -5px 0 2px -2px ';
            let styles = {
                width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
                'min-width': this.displayedTimeframeSelected.label !== 'D' ? ((8 * 60 * 60 * 1000) * timePixelRatio) + 'px' : '',
                left: (this.TimeDiff(this.timeFrameStart, timeFrame.fromDate) * timePixelRatio) + 'px',
                background: background,
                //'box-shadow': boxShadow,
            };
            return styles;
        },
        TimeDiff(a, b){
            return b._d.getTime() - a._d.getTime();
        },
        SelectToday(){
            let date = this.$helpers.getMomentTZ();
            this.onDatePicked(date, 'D', 36);

        },
        SelectMonth(month){
            this.onDatePicked(month.moment, 'M', 36);
        },
        SelectPreviousDate(){
            if(this.displayedTimeframeSelected.label === 'M'){
                let date = this.timeFrameStart.clone().add(-1, 'month');
                this.onDatePicked(date, 'M', 24);
            } else if(this.displayedTimeframeSelected.label === 'Y'){
                let date = this.timeFrameStart.clone().add(-1, 'year');
                this.onDatePicked(date, 'Y', 24);
            } else {
                let date = this.timeFrameStart.clone().add(-1, 'day');
                this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
            }


        },
        SelectNextDate(){
            if(this.displayedTimeframeSelected.label === 'M'){
                let date = this.timeFrameStart.clone().add(1, 'month');
                this.onDatePicked(date, 'M', 24);
            } else if(this.displayedTimeframeSelected.label === 'Y'){
                let date = this.timeFrameStart.clone().add(1, 'year');
                this.onDatePicked(date, 'Y', 24);
            } else {
                let date = this.timeFrameStart.clone().add(1, 'day');
                this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
            }

        },
        toggleDatePicker($event) {
            let view = this;
            let date = this.dateSelectionStart;

            this.$helpers.OpenDatepickerPopup(
                {viewsEnabled: ['Y'], selectedTab: this.displayedTimeframeSelected.label, date: date, hourlyEnabled: true, hourlySelection: [12, 24, 36], hourlySelected: view.hourlySelection},
                {
                    OnDateSelect: (date) => {

                    },
                    OnMonthSelect: (date) => {
                        view.onDatePicked(date, 'M');
                    },
                    OnDaySelect: (date, hours) => {
                        view.onDatePicked(date, 'D', hours);
                    },
                    OnYearSelect:  (date) => {
                        view.onDatePicked(date, 'Y');
                    }
                }, {elRelative: $event.currentTarget});
         },
        onDatePicked(date, timeFrameType, hours = 24){
            this.hourlySelection = hours;
            let before = this.timeFrameStart.clone();
            if(timeFrameType === 'Y'){
                this.timeFrameStart = date.clone().startOf('year');
            } else if(timeFrameType === 'M'){
                this.timeFrameStart = date.clone().startOf('month');
            } else {
                this.timeFrameStart = date.clone().startOf('day');
            }

            if(before.year() != this.timeFrameStart.year()){
                //month / year change => trigger reload
                let rosterDate = this.timeFrameStart.clone().startOf('month');
                this.setDateSelection(rosterDate, true);
            } else {
                this.setDateSelection(this.timeFrameStart, !this.rosterFromTo);
            }
            this.setDateSelection(this.timeFrameStart, false);
            let displayTimeFrame;
            if(timeFrameType === 'Y'){
                displayTimeFrame = {label: 'Y', length: this.$helpers.getMomentTZ().month(11).date(31).dayOfYear() * 24 * 60 * 60 * 1000, divisions: 12, timeStart: this.timeFrameStart.clone().month(0).date(1)};
            } else if (timeFrameType === 'M'){
                displayTimeFrame = {label: 'M', length: this.timeFrameStart.daysInMonth() * 24 * 60 * 60 * 1000, divisions: this.timeFrameStart.daysInMonth(), timeStart: this.timeFrameStart.clone().date(1)};
            } else {
                displayTimeFrame = {label: 'D', length: hours * 60 * 60 * 1000, divisions: hours, timeStart: this.timeFrameStart.clone()};
            }
            this.displayedTimeframes = [displayTimeFrame];
            this.timeFrameLength = displayTimeFrame.length;
            this.timeFrameEnd = this.timeFrameStart.clone().add(this.timeFrameLength, 'milliseconds');
            this.displayedTimeframeSelected = displayTimeFrame;


            this.$forceUpdate();

        },
        setDateSelection(date, calculateRosterFromTo){
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;

            this.currentDate = date.date();
            this.currentMonth = date.month();
            this.currentYear = date.year();
            //if(this.displayedTimeframeSelected.label === 'D') this.displayedTimeframeSelected.timeStart = date.clone();

            if(calculateRosterFromTo){
                //update vuex store with calculated from to => triggers reload of data via refresh

                let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
            } else {
                //dont update vuex from to, only update client side view
            }
        },
        OpenCreateShiftTemplateGroupFrameModal($event, g){
            let view = this;
            let from = this.$helpers.getMomentTZ().startOf('day');
            let to = from.clone().add(1, 'months');
            let items = [];
            Object.values(view.shiftTemplateGroupMap).sort((a,b) => {
                if(a.immutable == true){
                    return -1;
                } else {
                    return a.name.localeCompare(b.name);
                }
            }).forEach(group => {
                items.push({label: group.name, value: group.id, selected: group.id == g.id})
            })
            let selectedItem = items.find(i => i.selected == true);
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$t('shift.groups.title'), key: 'groupId', hidden: false, disabled: true, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: items,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: selectedItem,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('shift.groups.select'),
                        }, styles: {width: '442px'}},
                        {label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noValidFrom', hidden: false, disabled: false, type: 'bool', value: false},
                        {label: this.$t('workBalance.bonus.validFrom'), key: 'from', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('noValidFrom'), type: 'date', value: from, flexGroup: false},
                        {label: this.$t('workBalance.bonus.ongoingIndefinitely'), key: 'noValidTo', hidden: false, disabled: false, type: 'bool', value: false},
                        {label: this.$t('pages.employeeContract.validUntil'), key: 'to', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('noValidTo') , type: 'date', value: to, flexGroup: false},

                    ],
                    errorCheck: [
                        (entries) => {
                            let from = entries.noValidFrom ? null : entries.from;
                            let to = entries.noValidTo ? null : entries.to.clone().add(1,'days');
                            let overlap = false;

                            let frames = Object.values(this.shiftTemplateGroupFrameMap);
                            for(let i = 0; i < frames.length; i++){
                                let fFrom = frames[i].from ? view.$helpers.getMomentFromStringTZ(frames[i].from) : null;
                                let fTo = frames[i].to ? view.$helpers.getMomentFromStringTZ(frames[i].to) : null;
                                if(from == null && fFrom == null){
                                    overlap = true;
                                    break;
                                }
                                if(to == null && fTo == null){
                                    overlap = true;
                                    break;
                                }
                                if((from < fTo || from == null || fTo == null) && (to > fFrom || to == null || fFrom == null)){
                                    overlap = true;
                                    break;
                                }
                            }

                            if(overlap){
                                return {key: 'from', type: 'error', label: this.$t('shift.groups.overlap'), text: this.$t('shift.groups.overlapError')}
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        if(item.noValidFrom){
                            item.from = null;
                        }
                        if(item.noValidTo){
                            item.to = null;
                        }
                        delete item.noValidFrom;
                        delete item.noValidTo;
                        if(item.to != null){
                            item.to = item.to.add(1, 'days')
                        }
                        view.createShiftTemplateGroupFrame(item);
                    }
                },
                header: this.$t('shift.groups.newTimeframe'),
                centered: true,
                expanded: true,
                });
        },
        createShiftTemplateGroupFrame: function(item){
            let view = this;
            let url = '/api/sec/shifttemplategroupframe';
            let params = {
                storeId: this.storeId,
            }

            let payload = {
                from: item.from ? item.from.startOf('day').format() : null,
                to: item.to ? item.to.startOf('day').format() : null,
                groupId: item.groupId,

            }


            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setShiftTemplateGroupFrameMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.groups.timeframeAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.groups.addTimeframeError'));
                console.log(error)
            })

        },

        OpenDeleteShiftTemplateGroupFrameModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('shift.groups.deleteTimeframe'), description: this.$t('shift.groups.deleteTimeframeQuery'), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteShiftTemplateGroupFrame(data);
            }});
        },
        deleteShiftTemplateGroupFrame: function(item){
            let view = this;
            let url = '/api/sec/shifttemplategroupframe';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteShiftTemplateGroupFrameMapEntry", {id: item.id});

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.groups.timeframeDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.groups.deleteTimeframeError'));
                console.log(error)
            })

        },
        OpenEditShiftTemplateGroupFrameModal($event, item){
            let view = this;
            let tValidFrom = item.from ? this.$helpers.getMomentFromStringTZ(item.from) : this.$helpers.getMomentTZ().startOf('day');
            let tValidTo = item.to ? this.$helpers.getMomentFromStringTZ(item.to).add(-1, 'days') : this.$helpers.getMomentTZ().add(1, 'weeks').startOf('day').add(-1, 'days');
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id, flexGroup: false},
                        {label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noValidFrom', hidden: false, disabled: false, type: 'bool', value: item.from == null},
                        {label: this.$t('workBalance.bonus.validFrom'), key: 'from', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('noValidFrom'), type: 'date', value: tValidFrom, flexGroup: false},
                        {label: this.$t('workBalance.bonus.ongoingIndefinitely'), key: 'noValidTo', hidden: false, disabled: false, type: 'bool', value: item.to == null},
                        {label: this.$t('pages.employeeContract.validUntil'), key: 'to', hidden: view.$helpers.CheckDatafillKeysForHiddenInverted('noValidTo') , type: 'date', value: tValidTo, flexGroup: false},

                    ],
                    errorCheck: [
                        (entries) => {
                            let from = entries.noValidFrom ? null : entries.from;
                            let to = entries.noValidTo ? null : entries.to.clone().add(1,'days');
                            let overlap = false;
                            let tooSmall = false;

                            let fFrom = null;
                            let fTo = null;

                            let frames = Object.values(this.shiftTemplateGroupFrameMap);
                            for(let i = 0; i < frames.length; i++){
                                let shiftFrame = view.frameShiftIntervalMap[frames[i].id];
                                if(shiftFrame != null){
                                    fFrom = view.$helpers.getMomentFromStringTZ(shiftFrame.from).startOf('day');
                                    fTo = view.$helpers.getMomentFromStringTZ(shiftFrame.to).add(1,'days').startOf('day');
                                    if(frames[i].id != entries.id){
                                        if(from == null && fFrom == null){
                                            overlap = true;
                                            break;
                                        }
                                        if(to == null && fTo == null){
                                            overlap = true;
                                            break;
                                        }
                                        if((from < fTo || from == null || fTo == null) && (to > fFrom || to == null || fFrom == null)){
                                            overlap = true;
                                            break;
                                        }
                                    } else {
                                        if(from != null && from > fFrom){
                                            tooSmall = true;

                                            break;
                                        }
                                        if(to != null && to < fTo){
                                            tooSmall = true;
                                            break;
                                        }
                                    }
                                }


                            }

                            if(overlap){
                                return {key: 'from', type: 'error', label: this.$t('shift.groups.overlap'), text: this.$t('shift.groups.timeframeOverlap', [fFrom.format("DD.MM.YYYY"), fTo.add(-1, 'days').format("DD.MM.YYYY")]) }
                            } else if(tooSmall){
                                return {key: 'from', type: 'error', label: this.$t('shift.groups.invalidTimeframe'), text: this.$t('shift.groups.timeframeSmall', [fFrom.format("DD.MM.YYYY"), fTo.add(-1, 'days').format("DD.MM.YYYY")]) }
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        if(item.noValidFrom){
                            item.from = null;
                        }
                        if(item.noValidTo){
                            item.to = null;
                        }
                        delete item.noValidFrom;
                        delete item.noValidTo;
                        if(item.to != null){
                            item.to = item.to.add(1, 'days')
                        }
                        view.editShiftTemplateGroupFrame(item);
                    },

                },
                header: this.$t('shift.groups.editTimeframe'),
                centered: true,
                expanded: true,
            });
        },
        editShiftTemplateGroupFrame: function(item){
            let view = this;
            let url = '/api/sec/shifttemplategroupframe';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                from: item.from ? item.from.startOf('day').format() : null,
                to: item.to ? item.to.startOf('day').format() : null,

                updateFields: ["from", "to"]
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.draggingTimeFrame = null;
                view.draggingTime = null;
                view.$helpers.GetShiftTemplateGroupFrameMap(true, false, view.currentYear);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('shift.groups.timeframeEdited'));
            }).catch(function (error) {
                view.draggingTimeFrame = null;
                view.$helpers.GetShiftTemplateGroupFrameMap(true, false, view.currentYear);
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.groups.editTimeframeError'));
                console.log(error)
            })

        },
        StartDragTimeFrame($event, timeFrame, isStart){
            let view = this;
            this.dragging = true;
            this.draggingStart = isStart;
            this.draggingTimeFrame = timeFrame;
            this.draggingTimeInit = isStart ? timeFrame.fromDate.clone() : timeFrame.toDate.clone();
            this.draggingStartPos = {x: window.mouse.x, y: window.mouse.y};
            this.draggingHandle = $event.currentTarget;
            let limitFrom = null;
            let limitTo = null;
            let startOfYear = this.$helpers.getMomentFromValuesTZ(this.currentYear, 0, 1);
            let endOfYear = startOfYear.clone().add(1, 'year');
            let shiftInterval = view.frameShiftIntervalMap[timeFrame.frame.id];
            if(isStart){
                //if shiftinterval exists the limtTo is the left side of the interval, else it is the right side of the frame -  1 day
                limitTo = shiftInterval ? view.$helpers.getMomentFromStringTZ(shiftInterval.from).startOf('day') : timeFrame.toDate.add(-1,'days').clone();
                //find the next groupframe before the current frame
                let smallerThan = timeFrame.fromDate.clone();
                let beforeFrame = null;
                Object.values(view.shiftTemplateGroupFrameMap).forEach(f => {
                    if(f.from == null){
                        if(beforeFrame == null && f.id != timeFrame.frame.id){
                            beforeFrame = f;
                            limitFrom = startOfYear
                        }
                    } else {
                        let actualTo = view.$helpers.getMomentFromStringTZ(f.from).add(1, 'days').startOf('day');
                        if(actualTo.isSameOrBefore(smallerThan) && f.id != timeFrame.frame.id){
                            if(limitFrom == null || actualTo > limitFrom){
                                limitFrom = actualTo;
                                beforeFrame = f;
                            }
                        }
                    }

                });
                if(beforeFrame != null){
                    //check if frame before has shiftinterval, if yes set limitFrom to 'to' of that interval
                    let beforeFrameInterval = view.frameShiftIntervalMap[beforeFrame.id];
                    if(beforeFrameInterval){
                        limitFrom = view.$helpers.getMomentFromStringTZ(beforeFrameInterval.to).add(1, 'days').startOf('day');
                    }
                }
            } else {
                //if shiftinterval exists the limtFrom is the right side of the interval, else it is the left side of the frame +  1 day
                limitFrom = shiftInterval ? view.$helpers.getMomentFromStringTZ(shiftInterval.to).add(1, 'days').startOf('day') : timeFrame.fromDate.add(1,'days').clone();
                //find the next groupframe after the current frame
                let biggerThan = timeFrame.toDate.clone();
                let afterFrame = null;
                Object.values(view.shiftTemplateGroupFrameMap).forEach(f => {
                    if(f.to == null){
                        if(afterFrame == null && f.id != timeFrame.frame.id){
                            afterFrame = f;
                            limitTo = endOfYear
                        }
                    } else {
                        let actualFrom = view.$helpers.getMomentFromStringTZ(f.to).add(-1, 'days').startOf('day');
                        if(actualFrom.isSameOrAfter(biggerThan) && f.id != timeFrame.frame.id){
                            if(limitTo == null || actualFrom < limitTo){
                                limitTo = actualFrom;
                                afterFrame = f;
                            }
                        }
                    }

                });
                if(afterFrame != null){
                    //check if frame after has shiftinterval, if yes set limitTo to 'from' of that interval
                    let afterFrameInterval = view.frameShiftIntervalMap[afterFrame.id];
                    if(afterFrameInterval){
                        limitTo = view.$helpers.getMomentFromStringTZ(afterFrameInterval.from).startOf('day');
                    }
                }
            }

            this.DragWatch(limitFrom, limitTo);
        },
        DragWatch(limitFrom = null, limitTo = null){
            var view = this;
            var time = view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
            var timeLimit = !view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
            if($(this.$el).find('.drag-info').length > 0) $(this.$el).find('.drag-info').css({left: (window.mouse.x - ($(this.$el).find('.drag-info')[0].getBoundingClientRect().width * .5)) + 'px', top: (this.draggingHandle.getBoundingClientRect().top - 45)+ 'px'});
            var totalWidth = $(this.$el).find('.grid').width() - 225;
            var timePixelRatio = totalWidth / this.timeFrameLength;

            var delta = window.mouse.x - this.draggingStartPos.x;
            var deltaTime = this.draggingTimeInit.clone().add(delta / timePixelRatio, 'milliseconds');
            time.year(deltaTime.year());
            time.month(deltaTime.month());
            time.date(deltaTime.date());
            if(view.draggingTimeFrame.toDate._d.getTime() - view.draggingTimeFrame.fromDate._d.getTime() < (24 * 60 * 60 * 1000)) {
                if(time === view.draggingTimeFrame.fromDate) view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'days');
                else view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'days');
            }
            if(limitFrom != null && time.isBefore(limitFrom)){
                time = limitFrom.clone();
                if(view.draggingStart){
                    view.draggingTimeFrame.fromDate = time;
                } else {
                    view.draggingTimeFrame.toDate = time;
                }

            }
            if(limitTo != null && time.isAfter(limitTo)){
                time = limitTo.clone();
                 if(view.draggingStart){
                    view.draggingTimeFrame.fromDate = time;
                } else {
                    view.draggingTimeFrame.toDate = time;
                }
            }

            if(time === view.draggingTimeFrame.fromDate) {
                view.draggingTime = {fromDate: time.clone(), toDate: view.draggingTimeFrame.toDate};
                view.$helpers.SetMomentTimeFromMoment(view.draggingTimeFrame.fromDate, time);
            } else {
                view.draggingTime = {fromDate: view.draggingTimeFrame.fromDate, toDate: time.clone()};
                view.$helpers.SetMomentTimeFromMoment(view.draggingTimeFrame.toDate, time);
            }

            time.seconds(0);
            time.milliseconds(0);

            view.$forceUpdate();
            requestAnimationFrame(function(){
                if(window.mouse.click) view.DragWatch(limitFrom, limitTo);
                else {
                view.dragging = false;
                requestAnimationFrame(function(){
                    view.EndDragTimeFrame();
                });
                }
            });
        },
        EndDragTimeFrame(){
            let view = this;
            let timeframe = this.draggingTimeFrame;
            let groupframe = timeframe.frame;
            let item = {id: groupframe.id, from: groupframe.from == null ? null : this.draggingTime.fromDate.startOf('day'), to: groupframe.to == null ? null : this.draggingTime.toDate.startOf('day')}
            this.editShiftTemplateGroupFrame(item);
        },
        loadFrameShiftIntervals : function(payload) {

            let url = '/api/sec/shifttemplategroupframe/shiftintervals';
            let params = {
                storeId: this.$store.state.storeId,
            }

            return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
            }).then(response => {

                return response.data


            })


        },


    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .header .add{
        position:absolute;
        top: -0px;
        right: 22px !important;
        transform: scale(0.55)  !important;
        cursor: pointer;
    }

    .header .edit{
        position:absolute;
        top: -0px;
        right: 6px !important;
        transform: scale(0.55) !important;
        cursor: pointer;
    }

    .header .edit .fa-edit {
        transform: scale(0.5);
    }

    .header .remove .fa-circle {
        color: #e51c50 !important;
    }
    .templategroup-view{
        position: relative;
    }

    .templategroup-view > .header{
        background: var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;
        z-index: 2;

    }
    .templategroup-view > .header > * {
        display: inline-flex;
        align-items: center;
    }

    .templategroup-view > .header {
        justify-content: center;

    }
    .templategroup-view > .header > .button.filter{

        float: initial;
        margin: 0 10px;
        transform: translateY(1px);

    }

    .options{
        display: inline-block;
    }

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 25px;
        width: 35px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 190%;
        cursor: pointer;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    .options .label.selected, .options .label:hover{
        background: #6d8d23;
        color: white;
    }

    .grid{
        padding-top: 40px;
        text-align: center;
        position: relative;
        height: 100%;
    }

    .grid > .header{
        position: fixed;
        top: 145px;
        left: 6px;
        width: 100%;
        z-index: 20;
        padding-left: 10px;
    }

    .group{
        margin-bottom: 10px;
    }

    .group > .header{
        width: 255px;
        height: 19px;
        background: #6d8d23;
        border-top-left-radius: 50px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 50px;
        position: relative;
        z-index: 2;
        margin-left: 5px;
    }

    .group > .header .label{
        color: white;
        font-size: 13px;
        padding-left: 20px;
    }
    .group.group-null > .header .label{
        padding-left: 10px;
    }



    .group > .header .fa-stack{
        position: absolute;
        right: -10px;
        transform: scale(0.55);
        top: -4px;
        margin: 0;
        cursor: pointer;
    }


    .group > .header .fa-stack > *{
        pointer-events: none;
    }

    .group > .header .fa-stack.add{
        right: 6px;
    }
    .group > .header .fa-stack *:not(.fa-circle){
        color: #6d8d23;
    }
    .group > .header .fa-stack .fa-circle{
        color: #e5e5e5;
    }
    .group > .header .fa-stack:hover .fa-circle{
        color: #707070 !important;
    }
    .group > .header .fa-stack:hover *:not(.fa-circle):not(.fa-arrows-alt){
        color: #e5e5e5 !important;
    }
    .group > .header .fa-stack.drag{
        right: initial;
        left: -10px;
    }
    .group > .header .fa-stack.drag .fa-arrows-alt{
        line-height: 130%;
        font-size: 20px;
        color: white;
    }

    .group > .header .fa-stack.drag .fa-circle{
        display: none;
    }


    .templategroup .fa-stack{

        position: absolute;
        right: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .templategroup:hover .fa-stack.detail{
        opacity: 1;
    }
    .templategroup .fa-stack.detail{
         opacity: 1;
        cursor: pointer;
        font-size:25px;
        width:25px;
        height:25px;
        right:5px;
    }

    .templategroup .fa-stack.detail:hover .fa-circle{
        color: #6d8d23 !important;
    }

    .templategroup .fa-stack.detail:hover .fa-map{
        color: #404040 !important;
    }

    .templategroup .fa-stack > .fas:not(.fa-circle){
        transform: scale(.55);
    }


    .row{
        position: relative;
        width: calc(100% - 215px);
        padding: 5px;
        margin-left: 260px;
        height: 45px;
    }

    .grid .templategroup{
        position: absolute;
        top: 0;
        left: -245px;
        height: 46px;
        margin-bottom: 5px;
        padding-left: 45px;
        width: 245px;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1);
        z-index: 12;
    }

    .templategroup .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
    }

    .templategroup .name {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 20px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 0px;
        font-family: DistrictProBold;
        max-width: 100%;
        overflow: hidden;
    }

    .templategroup .name.shadow{
        height: 15px;
        white-space: nowrap;
        width: 30px;
        box-shadow: inset -30px 0 7px -7px var(--bg) !important;
        position: absolute;
        right: 0;
        top: 0;
    }

    .templategroup .buttons {
        font-size: 13px;
    }

    .templategroup .buttons .first{
        position: absolute;
        top: 3px;
    }

    .templategroup .buttons .second{
        position: absolute;
        top: 6px;
    }
    .row:hover .templategroup .name.shadow{
        box-shadow: inset -30px 0 7px -7px var(--contrast-2) !important;
    }
    .templategroup .progress {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 30px;
        height: 6px;
        border-radius: 100px;
        background: var(--contrast-6);
        left: 45px;
        overflow: hidden;
    }

    .templategroup .entitled {
        position: absolute;
        width: calc(100% - 45px);
        margin: auto;
        top: 22px;
        height: 24px;
        left: 45px;
        overflow: hidden;
    }

    .templategroup .entitled .label{
        float: left;
        font-size: 12px;
        color: var(--contrast-5);
    }

    .templategroup .progress .progress-bar {
        position: absolute;
        width: 00%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: var(--contrast-5);
        left: 0;
    }

    .templategroup .progress .progress-bar{
    }


    .templategroup .add{
        position:absolute;
        top: -0px;
        right: -5px;
        transform: scale(0.4);
        cursor: pointer;
    }
    .templategroup .add .fa-plus{
        transform: scale(0.8);
    }

    .templategroup .remove, .templategroup .edit{
        position: absolute;
        right: 5px;
        top: 1px;
        margin: 0;
        transform: scale(0.65);
        cursor: pointer;
    }

    .templategroup .edit1, .templategroup .edit2{
        position: absolute;
        right: 5px;
        top: 1px;
        margin: 0;
        transform: scale(0.65);
        cursor: pointer;
    }

    .templategroup .edit1 {
        position: absolute;
        right: 100px;
    }
    .templategroup .edit2 {
        position: absolute;
        right: 80px;
    }
    .templategroup .edit {
        position: absolute;
        right: 25px;
    }

    .templategroup .remove .fa-minus {
        transform: scale(0.7);
    }
    .templategroup .edit .fa-edit {
        transform: scale(0.5);
    }
    .templategroup .edit1 .fa-edit {
        transform: scale(0.5);
    }
    .templategroup .edit2 .fa-pencil-alt {
        transform: scale(0.6);
    }


    .templategroup .edit .fa-copy {
          transform: scale(0.6);
      }
    .templategroup .remove .fa-circle {
        color: #e51c50;
    }


    .event-info, .timeframe-popup, .drag-info, .drag-group{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: var(--bg);
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
        z-index: 20;
    }

    .drag-info .description{
        color: var(--contrast-4);
        z-index: 20;
    }

    .drag-group{
        background: none;
        box-shadow: none;
        z-index: 100;
        pointer-events: none;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
    .timeframe-popup{
        pointer-events: initial;
        z-index: 11;
    }

    .timeframe-popup .button{
        position: relative;
        font-weight: 600;
        text-align: center;
        margin: 5px 15px;
        width: 120px;
        display: block;
        height: 18px;
        border-radius: 100px;
        line-height: 100%;
    }

    .timeframe-popup .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }



    .time-marks{
        pointer-events: none;
        position: fixed;
        left: 260px;
        top: 200px;
        width: calc(100% - 278px);
        height: 100%;
        z-index: 10;
        padding: 0;
        white-space: nowrap;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }


    .time-marks.labels{
        z-index: 13;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px  var(--contrast-1);
        background: none;
    }


    .time-marks .mark.day-split{
        box-shadow: inset 3px 0px 0 -1px  var(--contrast-4);
    }



    .time-marks.labels .mark{
        z-index: 13;
        height: 20px;;
    }

    .timeframe{
        position: absolute;
        height: calc(100% - 10px);
        background: #cccccc;
        z-index: 11;
        /*border-radius: 5px; */
        cursor: pointer;
        min-width: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timeframe:hover{
        overflow: visible;
    }

    .timeframe .label{
        color: white;
        white-space: nowrap;
        position: absolute;
        left: 5px;
        right: 5px;
        margin: auto;
        text-align: center;
        pointer-events: none;
        width: auto;
        overflow: hidden;
    }


    .timeframe .shadow{
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        width: 100%;
        height: 100%;
        box-shadow: inherit !important;
        border-radius: 5px;
        z-index: -2;
    }

    .timeframe.show-under:hover .label{
        left: -1000px;
        right: -1000px;
        bottom: -25px;
        background: inherit;
        padding: 1px 5px;
        z-index: 10;
        width: fit-content;
        display: inline-block;
        border-radius: 5px;
    }

    .timeframe .handle{
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 15px;
        margin: auto;
        cursor: col-resize;
        color: #9f9f9f;
        text-align: center;
        transition: .2s;
        opacity: 0;
    }


    .timeframe .handle .inner{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background: #9f9f9f;
        width: 2px;
        height: calc(100% - 20px);
        pointer-events: none;
    }

    .timeframe:hover .handle{
        opacity: 1;
    }

    .handle.start{
        left: -12px;

    }

    .handle.end{
        right: -12px;
    }
    .timeframe .handle.end{
    }

    .grid .backdrop{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 260px;
        background: var(--bg);
        /*-webkit-box-shadow: 0 0 30px  var(--bg);
        box-shadow: 0 0 15px 10px  var(--bg);*/
        z-index: 2;
        pointer-events: none;
    }

    .scrollbar-container{
        width: 100%;
        overflow-x: hidden;
        padding-top: 37px;
    }
    .loading{
        filter: none !important;
        position:absolute;
        box-sizing:content-box;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100vh);
        background: rgba(0,0,0,.5);
        z-index: 100;
    }
    .loading .fa-spinner{
        position:absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        font-size: 50px;
        color: var(--contrast-3);
        animation-name: spin;
        animation-duration: 2000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .row .bottom-line,.row .top-line{
        box-shadow: inset 0px 2px 0 -1px  var(--contrast-1);
        height: 1px;
        position: absolute;
        bottom: 0px;
        width: calc(100% + 245px);
        left: -245px;
    }

    .row .top-line{
        bottom: initial;
        top: 0px;
        display: none;
    }

    .row:nth-child(4) .top-line{
        display: initial;
    }

    .fa-refresh:before{
        content: '\f021';
    }

    .group.show-drag-area:not(.group-dragged){
        padding-top: 20px;
        margin-top: 5px;
    }
    .group .drag-catch-area{
        display: none;
    }
    .group .drag-catch-area.last{
        display: none;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area{
        display: inline-block;
        width: 230px;
        height: 19px;
        left: 5px;
        margin-top: -45px;
        background: none;
        border: dashed 1px var(--contrast-5);
        border-radius: 50px;
        position: absolute;
        z-index: 5;
        font-size: 13px;
        color: transparent;
        text-align: left;
        padding-left: 25px;
    }

    .group.show-drag-area:not(.group-dragged) .drag-catch-area:hover{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        color: var(--contrast-4);
        line-height: 16px;
        font-weight: 600;
    }
    .group .drag-catch-area.last{
        display: none !important;
    }
    .group.show-drag-area-last
    {
        padding-bottom: 20px;
    }
    .group.show-drag-area-last .drag-catch-area.last{
        display: inline-block !important;
    }
    .group.show-drag-area:not(.group-dragged) .drag-catch-area.last{
        margin-top: 4px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area{
        width: 210px;
        left: 25px;
    }

    .group.sub-spot.show-drag-area:not(.group-dragged) .drag-catch-area:hover{
        background: var(--contrast-2);
        border: solid 1px var(--contrast-5);
        color: var(--contrast-4);
        line-height: 16px;
        font-weight: 600;
    }


    .group.show-drag-area:not(.group-dragged) .header{
        background: var(--contrast-6);
    }

    .group-dragged{
        opacity: .5;
    }

    .group.sub-spot > .header{
        width: 235px;
        margin-left: 25px;
    }

    .group.sub-spot .templategroup{
        width: 225px;
        left: -225px;
    }


    .positions-filter, .templategroup-filter {
        position: absolute;
        top: 4px;
        left: 208px;
        z-index: 3;
    }

    .templategroup-filter {
        /*left: 80px;*/
    }

    .header > .filter.arrow.left{
        margin-right: 0;
    }

    .header > .filter.arrow.right{
        margin-left: 0;
    }
    .header > .filter.arrow{
        justify-content: center;
        height: 20px;
        width: 20px;
    }

    .filter.arrow .fas{
        transform: none;
        align-self: center;
    }



    .time-marks.monthly  .label{
        position: absolute;
        display: block;
        top: -14px;
        left: 0;
        right: 0;
        text-align: center;
        width: 100%;
        bottom: initial;
        height: 34px;
        line-height: 35px;
        cursor: pointer;
    }

    .day-container{
        height: 80px;
        width: calc(100% - 278px);
        white-space: nowrap;
        position: fixed;
        left: 260px;
        top: calc((2 * var(--header-height)) + var(--tab-menu-height) + 21px); /* 14px is the space needed to fit the weather and filter button */
        z-index: 12;
        background: var(--bg);
        overflow: hidden;
    }

    .day-container .day{
        transition: .2s;
        transform: scale(1);
        position: relative;
        opacity: 1 !important;
        padding-bottom: 0;
        height: 75px;
        width: 40px;
        margin: 0;
        cursor: pointer !important;
        top: 11px;
        z-index: 10;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px #d5d5d5, inset 0px 0px 0 -1px #d5d5d5;
        border-radius: 0;
    }

    .day-container .day .name{
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
        cursor: pointer;
    }
    .day-container .day .date {

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
        cursor: pointer;
    }

    .day-container .day .income {
        width: calc(100% + 0px);
        position: absolute;
        bottom: 05px;
        font-size: 10px;
        background: transparent;
        height: 21px;
        padding-top: 3px;
        text-align: center;
        z-index: -1;
        cursor: pointer;
        box-shadow: inset 0px 2px 0 -1px #d5d5d5;
    }
    .day-container .day .weather {
        width: calc(100% + 1px);
        position: absolute;
        top: -16px;
        font-size: 10px;
        background: var(--bg);
        height: 25px;
        left: -1px;
        padding-top: 3px;
        padding-left: 1px;
        text-align: center;
        z-index: -1;
        cursor: pointer;
    }
    .day-container .day .weather .label{
        font-family: DistrictProLight;
        pointer-events: none;
        font-weight: 200;
        color: var(--contrast-4);
    }
    .day-container .day .weather .picture{

        width: 15px;
        margin-top: 2px;
        margin-left: 5px;
        height: 15px;
        display: inline-block;
        pointer-events: none;
        float: left;
    }
    .day-container .day:first-child .income {
        width: calc(100% + 1px);
        left: -1px;
    }
    .day-container .day .income .income-bar {
        position: absolute;
        border-radius: 100px;
        height: 8px;
        left: 5px;
        top: 9px;
        pointer-events: none;
    }
    .day-container .day .income .income-bar.red{
        background: #e51c50;

    }
    .day-container .day .income .income-bar.gray{
        background: var(--contrast-3);
    }

    .day-container .day .income .income-bar.green{
        background: #6d8d23;
    }

    .day-container-selected{
        position: fixed;
        top: 62px;
        left: 0px;
        margin: 0;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
    }

    .day-container-selected .day{

        position: fixed;
        left: 0px;
        margin: 0;
        margin-top: -5px;
        z-index: 10000 !important;
        background: var(--bg);
        border-radius: 0;
        width: 90px;
        height: 40px;
        top: 121px;
        cursor: pointer;
    }

    .day-container-selected .day *{
        pointer-events: none;
    }
    .day-container-selected .day .shadow{

        position: absolute;
        height: 40px;
        width: 140px;
        -webkit-box-shadow: 0 0 1px 0 #808080;
        box-shadow: 0 0 1px 0 #808080;
        left: -50px;
        top: 0;
    }

    .day-container-selected .day .name{

        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: 0;
        right: 0;
        top: -10px;
        margin: auto;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: var(--contrast-4);
        border-radius: 0 !important;
        padding-top: 0 !important;
        background: none !important;
        cursor: pointer;
    }


    .day-container-selected .day .date{
        position: absolute;
        height: 50%;
        width: 100%;
        left: 0;
        bottom: -20px;
        right: 0;
        top: 0;
        margin: auto;
        text-align: center;
        font-size: 10px;
        padding-top: 0 !important;
        border-radius: 0 !important;
        background: none !important;
        color: var(--contrast-4);
        cursor: pointer;
    }



    .header.date{
        display: inline-flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        background: none;
        left: 0;
        right: initial;
        width: initial;
        padding: 0 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
    }

    .header.date .label.today{
        font-size: 15px;
        cursor:pointer;
    }

    .header.date .fa-angle-right,.header.date .fa-angle-left{
        color: var(--contrast-4);
        font-size: 20px;
        padding: 5px;
        cursor:pointer;
    }

    .header.date .fa-angle-right:hover,.header.date .fa-angle-left:hover, .header.date .fa-calendar:hover, .header.date .today:hover{
        color: var(--bg) !important;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin: -3px 5px 0;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
    }
    .timeframe.create{
        box-shadow: inset 0 0 0 1px var(--contrast-3);
        background: none;
    }


    .day .day-text{
        transform: scale(1) translateY(6px);
        transition: .2s;
        height: 37px;
        cursor: pointer;
    }

    .day .day-text:hover {
        transform: scale(1.3) translateY(1px);
    }

    .day .day-text * {
        pointer-events: none;
    }

    .sub-header{
        display: flex;
        justify-content: left;
        width: calc(100vw - 277px);
        left: 260px;
        height: 72px;
        position: fixed;
        top: 144px;
        background: var(--bg);
        box-shadow: 0 2px 0 -1px #d5d5d5;
        z-index: 12;
    }
    .sub-header .title{
        position: relative;
        display: flex;
        justify-content: center;
        padding: 0;
        align-self: flex-start;
        top: 1px;
    }

    .sub-header .title .label{
        font-size: 16px;
        font-weight: 500;
    }

    .sub-header .title .label.year{
        color: #6d8d23;;
        margin-right: 5px;
        font-weight: 800;
    }

    .templategroup .background{
        position: absolute;
        top: 0;
        left: -100px;
        width: calc(100% + 100px);
        height: 100%;
        background: var(--bg);
        box-shadow: none;
        z-index: -1;
    }

    .templategroup .background.shadow{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 1px);
        background: var(--bg);
        z-index: -1;
        box-shadow: inset 0px -2px 0 -1px var(--contrast-1) !important;
    }


    .grid .row:hover .templategroup .background.shadow{
        background: var(--contrast-2);
        border-radius: 0;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
        box-shadow: none !important;
    }


    .event-marker{
        display: inline-block;
        height: 0;
        width: 0;
        font-size: 9px;
        text-align: center;
        padding-top: 2px;
        bottom: 26px;
        left: -2px;
        position: absolute;
        line-height: 110%;
        cursor: default;
        height: 13px;
        width: 10px;
        z-index: 1;
    }

    .always-work-bar{
        position: absolute;
        top: 0;
        height: 100%;
        background: #e5154f;
        z-index: -1;
        pointer-events: none;
    }

    .day-container.background{
        background: var(--bg);
        z-index: 12;
        margin-top: -12px;
    }



    .sub-header-button-container {
        width: 260px;
        height: 72px;
        padding-top: 42px;
        z-index: 13;
        position: fixed;
        background: var(--bg);
        top: 144px;
        box-shadow: 0 1px 1px 0 var(--contrast-1);
    }

    .sub-header-button-container > .button{
        margin: 0 0 0 15px !important;
       height: 25px !important;
       width: 25px !important;
       float: left;
       cursor: pointer;
        font-size: 17px;
        color: var(--contrast-4);
    }
    .sub-header-button-container > .button:first-of-type{
       float: left !important;
    }
    .sub-header-button-container > .button:last-of-type{
       float: right;
    }


    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }

    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
